import { useEffect, useState } from 'react';
import { capitalize } from '@mui/material';

export default class Utils {
  static copyText(str: any) {
    const val = str;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  static alert() {
    alert(this);
  }

  static async base64ToImageFile(url: string, filename: string) {
    const dataMime = (url.match(/^data:([^;]+);/) || [])[1];
    const res = await fetch(url);
    const blob = await res.blob();
    const mimeType = dataMime || blob.type || 'image/jpeg';
    const ext = (() => {
      if (mimeType.includes('png')) return 'png';
      if (mimeType.includes('webp')) return 'webp';
      return 'jpg';
    })();
    const safeName = filename.replace(/\.(png|jpe?g|webp)$/i, '') || 'profile';
    return new File([blob], `${safeName}.${ext}`, { type: mimeType });
  }
}

export function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

export function isEmailValid(email: string): boolean {
  return !!String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\\-]+/g, '') // Remove all non-word chars
    .replace(/\\-\\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

export const getSubscriptionType = (type: string) => {
  switch (type) {
    case 'advance':
      return 'Advanced';
    case 'pro':
      return 'Premium';
    default:
      return capitalize(type);
  }
};
